import { TableState } from "@dis/shared";

export const NGXS_APP_STORAGE_CONFIG = {
  keys: [
    TableState,
  ]
}
